// extracted by mini-css-extract-plugin
export default {"head":"Head__head___EKPqt"};